import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './app-landing.component.html',
  styleUrls: ['./app-landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppLandingComponent implements OnInit {

  constructor(
    private router: Router,
    private cdRef: ChangeDetectorRef) { }

  /**
   * Function that redirects to desired component.
   */
  ngOnInit() {
    this.router.navigate([`Tasks`]);
  }

}
